import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/stores/authStore";
import { AuthModal } from "@/components/AuthModal";
import { C } from "./landing/data";
import { Header } from "./landing/Header";
import { Hero } from "./landing/Hero";
import { Features, ComparisonAndBeyond } from "./landing/Features";
import { SecurityTools } from "./landing/SecurityTools";
import { Footer } from "./landing/Footer";

export const LandingPage = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated, logout } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const openLogin = () => setShowAuthModal(true);

  return (
    <div className="min-h-screen overflow-x-hidden" style={{ background: C.bg, color: C.text1 }}>
      <Header
        navigate={navigate}
        isAuthenticated={isAuthenticated}
        user={user}
        logout={logout}
        onLogin={openLogin}
      />
      <Hero navigate={navigate} />
      <Features navigate={navigate} onLogin={openLogin} />
      <SecurityTools />
      <ComparisonAndBeyond navigate={navigate} onLogin={openLogin} />
      <Footer navigate={navigate} />
      <AuthModal open={showAuthModal} onOpenChange={setShowAuthModal} />
    </div>
  );
};
